export const parseData = (serializedCache: string) =>
  eval('(' + serializedCache + ')');
